// import log from '../services/logger_service';

import FontLoaderUtil from '../utils/font_loader_util';

export default function initialize() {
  return Promise.all([FontLoaderUtil.loadFonts()]);
}
